import React, { useContext, useState, useMemo, useCallback } from "react";

const LoadingContext = React.createContext();

export function useLoading() {
  const context = useContext(LoadingContext);
  if (!context) {
    throw new Error("useLoading must be used within a LoadingProvider");
  }
  return context;
}

export function LoadingProvider({ children }) {
  const [loading, setLoading] = useState(false);
  const [progress, setProgress] = useState(0);

  // 开始加载
  const startLoading = useCallback(() => {
    setLoading(true);
    setProgress(0);
  }, []);

  // 更新进度
  const updateProgress = useCallback((newProgress) => {
    setProgress(Math.min(100, Math.max(0, newProgress)));
  }, []);

  // 结束加载
  const stopLoading = useCallback(() => {
    setProgress(100);
    setTimeout(() => {
      setLoading(false);
      setProgress(0);
    }, 100);
  }, []);

  const value = useMemo(
    () => ({
      loading,
      progress,
      startLoading,
      updateProgress,
      stopLoading,
    }),
    [loading, progress, startLoading, updateProgress, stopLoading]
  );

  return (
    <LoadingContext.Provider value={value}>
      {children}
    </LoadingContext.Provider>
  );
}